import { Icon } from "@design-system/Icon";
import { FlexCol } from "@design-system/Layout/Flex";
import { Text } from "@design-system/Typography/Text";
import { type FC, type PropsWithChildren } from "react";
import { useQuestionsTabTranslations } from "./i18n";

const Group: FC<PropsWithChildren> = ({ children }) => {
    return <FlexCol gap="1">{children}</FlexCol>;
};

const GroupTitle: FC<PropsWithChildren<{ id?: string }>> = ({
    children,
    id,
}) => {
    return (
        <Text variant="header2" id={id} p="3">
            {children}
        </Text>
    );
};

const EmptyGroup: FC = () => {
    const { t, keys } = useQuestionsTabTranslations();
    return (
        <FlexCol
            py="10"
            justifyContent="center"
            alignItems="center"
            w="full"
            className="bg-neutral-25"
        >
            <FlexCol gap="2" alignItems="center" className="my-8">
                <Icon name="search" />
                <FlexCol gap="1" alignItems="center">
                    <Text variant="body-sm-bold">
                        {t(keys.empty_questions_section_title)}
                    </Text>
                    <Text variant="body-sm" className="font-light">
                        {t(keys.empty_questions_section_subtitle)}
                    </Text>
                </FlexCol>
            </FlexCol>
        </FlexCol>
    );
};

type QuestionWrapperComponent = FC<PropsWithChildren> & {
    GroupTitle: typeof GroupTitle;
    Group: typeof Group;
    EmptyGroup: typeof EmptyGroup;
};

export const QuestionsWrapper: QuestionWrapperComponent = ({ children }) => {
    return (
        <FlexCol
            className="bg-tertiary border border-tertiary"
            br="lg"
            w="full"
            p="4"
            gap="3"
        >
            {children}
        </FlexCol>
    );
};

QuestionsWrapper.GroupTitle = GroupTitle;
QuestionsWrapper.Group = Group;
QuestionsWrapper.EmptyGroup = EmptyGroup;
